module.exports = __webpack_public_path__ + "img/05.44ddb117.png";